import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Services() {
  const [selectedService, setSelectedService] = useState<any>(null);

  const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  },
};

const modalVariants = {
  hidden: {
    opacity: 0,
    scale: 0.9,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    scale: 0.9,
    transition: { duration: 0.2 },
  },
};


  const telecomServices = [
    {
      name: 'AIRTEL',
      status: 'Available Now',
      available: true,
      icon: 'ri-signal-tower-line',
      color: 'text-red-600',
      bgColor: 'bg-red-50',
      shortDesc: 'SIM registration, activation, and state-based ordering system',
      fullDesc: 'Complete AIRTEL SIM card services including registration, activation, and our state-based ordering system. We handle the complete registration process, ensuring compliance with NCC regulations. Get your SIM activated quickly with our professional assistance.',
    },
    {
      name: 'MTN',
      status: 'Coming Soon',
      available: false,
      icon: 'ri-signal-tower-line',
      color: 'text-gray-400',
      bgColor: 'bg-gray-100',
      shortDesc: 'Full MTN services launching soon',
      fullDesc: 'MTN SIM card services will be available soon. Stay tuned for registration, activation, and ordering services.',
    },
    {
      name: 'GLO',
      status: 'Coming Soon',
      available: false,
      icon: 'ri-signal-tower-line',
      color: 'text-gray-400',
      bgColor: 'bg-gray-100',
      shortDesc: 'Full GLO services launching soon',
      fullDesc: 'GLO SIM card services will be available soon. Stay tuned for registration, activation, and ordering services.',
    },
    {
      name: '9mobile',
      status: 'Coming Soon',
      available: false,
      icon: 'ri-signal-tower-line',
      color: 'text-gray-400',
      bgColor: 'bg-gray-100',
      shortDesc: 'Full 9mobile services launching soon',
      fullDesc: '9mobile SIM card services will be available soon. Stay tuned for registration, activation, and ordering services.',
    },
  ];

  const otherServices = [
    {
      title: 'CPaaS',
      shortDesc: 'Embed voice, video, SMS, and chat into your apps without building infrastructure.',
      description: 'Communications Platform as a Service that allows your business to embed voice, video, SMS, and chat directly into apps or websites without building your own communication infrastructure. It enables personalized customer engagement, automates processes like OTP verification and reminders, and improves team collaboration—all while reducing operational costs. Ideal for customer support, marketing campaigns, and secure communications.',
      icon: 'ri-message-3-line',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      link: null,
    },
    {
      title: 'DSA Services',
      shortDesc: 'Promote 5G devices, SIM cards, and CUG services through professional agents.',
      description: 'Direct Selling Agent services specializing in promoting and acquiring customers for 5G-enabled devices, prepaid SIM cards, and related services such as Corporate/Closed User Groups (CUGs). Through trained and professional agents, we help businesses increase SIM activations, device uptake, and subscription growth. This ensures efficient market penetration, enhanced customer onboarding, and higher adoption rates of telecom products—all without the need for heavy infrastructure investment.',
      icon: 'ri-user-star-line',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      link: null,
    },
    {
      title: 'FinTech Services',
      shortDesc: 'Simplify payments, banking, lending, and investments with secure solutions.',
      description: 'Innovative financial solutions that simplify payments, banking, lending, and investments. From mobile wallets and online lending platforms to digital banking tools, our FinTech services help businesses and individuals perform secure and efficient transactions. We focus on financial inclusion, operational efficiency, and cost reduction.',
      icon: 'ri-bank-card-line',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      link: null,
    },
    {
      title: 'Business Registration',
      shortDesc: 'Complete guidance through incorporation, licensing, and compliance.',
      description: 'Complete guidance through the business registration process, including name reservation, incorporation, licensing, and compliance. Our services save time, reduce administrative hurdles, and ensure full legal compliance, whether you\'re starting a sole proprietorship, partnership, limited liability company, or NGO.',
      icon: 'ri-file-list-3-line',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      link: null,
    },
    {
      title: 'IT Support & Maintenance',
      shortDesc: 'Comprehensive IT support covering troubleshooting, network management, and security.',
      description: 'Comprehensive IT support covering hardware and software troubleshooting, network management, system updates, and cybersecurity monitoring. We minimize downtime, optimize system performance, and protect your business from digital threats, allowing you to focus on growth and productivity.',
      icon: 'ri-tools-line',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      link: null,
    },
    {
      title: 'Digital Marketing',
      shortDesc: 'Grow your online presence through SEO, social media, and content creation.',
      description: 'Grow your online presence through social media marketing, SEO, email campaigns, content creation, and digital advertising. Our data-driven strategies improve lead generation, brand awareness, and customer engagement, offering measurable results and ROI for businesses of all sizes.',
      icon: 'ri-megaphone-line',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      link: null,
    },
    {
      title: 'Skills Training',
      shortDesc: 'Professional training programs for career growth and digital literacy.',
      description: 'Professional skills training programs that enhance career growth, digital literacy, and entrepreneurial capabilities. Delivered virtually or in-person, our courses cover digital skills, business development, project management, public speaking, and personal growth. We empower individuals and teams to succeed in a competitive and evolving market.',
      icon: 'ri-graduation-cap-line',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      link: null,
    },
    {
      title: 'SIM Registration',
      shortDesc: 'Fast and reliable SIM card registration for all major Nigerian networks.',
      description: 'Fast and reliable SIM card registration services for all major Nigerian networks. We handle the complete registration process, ensuring compliance with NCC regulations. Get your SIM activated quickly with our professional assistance and state-based ordering system.',
      icon: 'ri-sim-card-line',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      link: '#become-agent',
      linkText: 'Register Your SIM',
    },
    {
      title: 'Crypto & Online Money Making Updates',
      shortDesc: 'Stay updated with cryptocurrency trends and legitimate online earning opportunities.',
      description: 'Stay updated with the latest cryptocurrency trends, trading strategies, and legitimate online money-making opportunities. Join our exclusive Telegram channel for daily updates, market analysis, investment tips, and proven methods to earn online. Get access to expert insights and a community of successful online entrepreneurs.',
      icon: 'ri-telegram-line',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      link: 'https://t.me/emileekaiofficial',
      linkText: 'Join Telegram Channel',
      external: true,
    },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleServiceClick = (service: any) => {
    if (service.link) {
      if (service.external) {
        window.open(service.link, '_blank', 'noopener,noreferrer');
      } else {
        const sectionId = service.link.replace('#', '');
        scrollToSection(sectionId);
      }
    }
  };

  const openModal = (service: any) => {
    setSelectedService(service);
  };

  const closeModal = () => {
    setSelectedService(null);
  };

  return (
    <motion.section
      id="services"
      className="py-24 bg-gradient-to-b from-gray-50 to-white"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={containerVariants}
    >

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-blue-600">Services</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Comprehensive technology solutions designed to empower your business and connect you to opportunities
          </p>
        </div>

        {/* <div className="mb-20">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Telecom & SIM Card Services
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {telecomServices.map((service, index) => (
              <div
                key={index}
                className={`relative p-8 rounded-3xl shadow-lg transition-all hover:shadow-xl ${
                  service.available ? 'bg-white border-2 border-orange-500' : 'bg-gray-50'
                }`}
              >
                {service.available && (
                  <div className="absolute top-4 right-4 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                    ✓ Available
                  </div>
                )}
                <div className={`w-16 h-16 ${service.bgColor} rounded-2xl flex items-center justify-center mb-6`}>
                  <i className={`${service.icon} text-3xl ${service.color}`}></i>
                </div>
                <h4 className={`text-2xl font-bold mb-2 ${service.available ? 'text-gray-900' : 'text-gray-400'}`}>
                  {service.name}
                </h4>
                <p className={`text-sm font-medium mb-3 ${service.available ? 'text-orange-600' : 'text-gray-400'}`}>
                  {service.status}
                </p>
                <p className="text-sm text-gray-600 mb-4">
                  {service.shortDesc}
                </p>
                <button
                  onClick={() => openModal(service)}
                  className={`inline-flex items-center gap-2 text-sm font-semibold ${service.available ? 'text-blue-600 hover:text-blue-700' : 'text-gray-400'} transition-colors whitespace-nowrap`}
                >
                  View More
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            ))}
          </div>
        </div> */}

        <div>
          {/* <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Additional Services
          </h3> */}
          <motion.div
            className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8"
            variants={containerVariants}
          >

            {otherServices.map((service, index) => (
              <motion.div
                key={index}
                variants={cardVariants}
                whileHover={{ y: -6 }}
                className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-xl transition-all"
              >

                <div className={`w-16 h-16 ${service.bgColor} rounded-2xl flex items-center justify-center mb-6`}>
                  <i className={`${service.icon} text-3xl ${service.color}`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">{service.shortDesc}</p>
                
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => openModal(service)}
                    className={`inline-flex items-center gap-2 ${service.color} font-semibold text-sm hover:gap-3 transition-all whitespace-nowrap`}
                  >
                    View More
                    <i className="ri-arrow-right-line"></i>
                  </button>
                  
                  {service.link && (
                    <>
                      <span className="text-gray-300">|</span>
                      <button
                        onClick={() => handleServiceClick(service)}
                        className={`inline-flex items-center gap-2 ${service.color} font-semibold text-sm hover:gap-3 transition-all whitespace-nowrap`}
                      >
                        {service.linkText}
                        <i className={`${service.external ? 'ri-external-link-line' : 'ri-arrow-right-line'}`}></i>
                      </button>
                    </>
                  )}
                </div>
              </motion.div>
            ))}
          </motion.div >
        </div>
      </div>

      {/* Modal */}
      <AnimatePresence>
      {selectedService && (
        <motion.div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={closeModal}
        >
          <motion.div
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto"
          >
            <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 flex items-center justify-between rounded-t-3xl">
              <div className="flex items-center gap-4">
                <div className={`w-14 h-14 ${selectedService.bgColor} rounded-2xl flex items-center justify-center`}>
                  <i className={`${selectedService.icon} text-2xl ${selectedService.color}`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">
                    {selectedService.title || selectedService.name}
                  </h3>
                  {selectedService.status && (
                    <p className={`text-sm font-medium ${selectedService.available ? 'text-orange-600' : 'text-gray-400'}`}>
                      {selectedService.status}
                    </p>
                  )}
                </div>
              </div>
              <button
                onClick={closeModal}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="px-8 py-6">
              <p className="text-base text-gray-700 leading-relaxed">
                {selectedService.description || selectedService.fullDesc}
              </p>

              {selectedService.link && (
                <div className="mt-8 pt-6 border-t border-gray-200">
                  <button
                    onClick={() => {
                      handleServiceClick(selectedService);
                      closeModal();
                    }}
                    className={`inline-flex items-center gap-2 px-6 py-3 ${selectedService.bgColor} ${selectedService.color} font-semibold rounded-lg hover:shadow-md transition-all whitespace-nowrap`}
                  >
                    {selectedService.linkText}
                    <i className={`${selectedService.external ? 'ri-external-link-line' : 'ri-arrow-right-line'}`}></i>
                  </button>
                </div>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
      </AnimatePresence>
    </motion.section>
  );
}